


































































































import { ConfirmModal, Scrollbar, SvgImage } from '@/app/components';
import { UserRoles } from '@/app/constants';
import store from '@/app/store';
import { computed, defineComponent, ref } from '@vue/composition-api';
import { useCart } from '../../composable';
import AssetCard from './AssetCard.vue';

export default defineComponent({
    name: 'Cart',
    components: {
        Scrollbar,
        ConfirmModal,
        AssetCard,
        SvgImage,
    },
    setup(_, { root }) {
        const { clearCart, cart, cartLimit } = useCart();

        const showClearCartModal = ref<boolean>(false);

        const isLegalRepresentative = computed(() => store.getters.auth.hasRole(UserRoles.LegalRepresentative));
        const isBlockchainEnabled = computed(() => store.getters.sharing.isBlockchainEnabled);
        const ethNetwork = computed(() => store.state.sharing.network);
        const hasWallet = computed(() => store.getters.organisation.hasWallet);

        const buyAssets = (id: string) => {
            root.$router.push({ name: 'contract-details', params: { type: 'create', id } });
        };

        const clearCartAssets = () => {
            clearCart();
            showClearCartModal.value = false;
        };

        return {
            cartLimit,
            isLegalRepresentative,
            showClearCartModal,
            cart,
            buyAssets,
            clearCartAssets,
            isBlockchainEnabled,
            ethNetwork,
            hasWallet,
        };
    },
});
